<script setup>
import { ref, computed } from 'vue';
import BaseBubble from './Base.vue';
import Icon from 'next/icon/Icon.vue';
import TranscriptionToggle from './TranscriptionToggle.vue';
import Caption from './Caption.vue';
import { useSnakeCase } from 'dashboard/composables/useTransformKeys';
import { useMessageContext } from '../provider.js';
import GalleryView from 'dashboard/components/widgets/conversation/components/GalleryView.vue';
import { ATTACHMENT_TYPES, MESSAGE_TYPES } from '../constants';

const emit = defineEmits(['error']);
const hasError = ref(false);
const showGallery = ref(false);
const { filteredCurrentChatAttachments, attachments, content, messageType } =
  useMessageContext();

// Transcrição automática (mídia do lead) fica retrátil; legenda que o
// atendente digita ao enviar é fala dele, mostra sempre.
const isIncoming = computed(() => messageType.value === MESSAGE_TYPES.INCOMING);

const handleError = () => {
  hasError.value = true;
  emit('error');
};

const attachment = computed(() => {
  return attachments.value[0];
});

const isReel = computed(() => {
  return attachment.value.fileType === ATTACHMENT_TYPES.IG_REEL;
});
</script>

<template>
  <BaseBubble
    class="overflow-hidden p-3"
    data-bubble-name="video"
    @click="showGallery = true"
  >
    <div class="relative group rounded-lg overflow-hidden">
      <div
        v-if="isReel"
        class="absolute p-2 flex items-start justify-end right-0 pointer-events-none"
      >
        <Icon icon="i-lucide-instagram" class="text-white shadow-lg" />
      </div>
      <video
        controls
        class="rounded-lg skip-context-menu w-full"
        :src="attachment.dataUrl"
        :class="{
          'max-w-48': isReel,
          'max-w-[200px]': !isReel,
        }"
        @click.stop
        @error="handleError"
      />
    </div>
    <TranscriptionToggle v-if="content && isIncoming" :content="content" />
    <Caption v-else-if="content" :content="content" />
  </BaseBubble>
  <GalleryView
    v-if="showGallery"
    v-model:show="showGallery"
    :attachment="useSnakeCase(attachment)"
    :all-attachments="filteredCurrentChatAttachments"
    @error="onError"
    @close="() => (showGallery = false)"
  />
</template>
